import React from 'react'
import moment from 'moment'
import LineChart from './LineChart'
import { round } from 'lodash'

export default function ProgramSurveyWithGraphModule(props) {
  const { name, slug, submissions, percent_change, organizationName, residentId, isStaffApp, resident } = props
  const hasScore = props["has_score?"]
  // TODO (David) Haven at college custom code
  // ORAS-PAT is a risk score: a rising score is not an increase in quality of life (TSO-232)
  const showPercentChange = hasScore && name != 'Haven At College Survey' && slug !== 'oras_pat'
  return isStaffApp ? 
    (
      <div className="pb-3" style={{backgroundColor: 'rgba(0,0,0,0.05)'}}>
        <div className="bg-white border-rounded shadow-sm" style={{ borderRadius: 8 }}>
          <b className="p-4 border-bottom d-block">{name}</b>
          {
            hasScore && 
            <div className="pt-4">
              <LineChart data={submissions} dataKey="get_score"/>
            </div>
          }
          <div className="">
            <div>
              <b className="border-top d-block p-4 mt-2">Submissions</b>
              {
                isStaffApp ?
                <div>
                  {
                    submissions.map((submission, index)=>(
                      <a key={submission.id} href={`/organizations/${organizationName}/residents/${residentId}/survey_submissions/${submission.id}?sender=${resident.sender_url}&sender_name=${resident.name}`} 
                          className="p-4 d-block text-black clickable border-bottom">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>Score: { hasScore ? round(submission.get_score, 2) : `Submission #${index}`}</div>
                          <div className="badge badge-primary">View</div>
                        </div>
                        <div className="text-secondary pt-1">{moment(submission.created_at).format("MM/DD/YYYY hh:mma")}</div>
                      </a>
                    ))
                  }
                </div>:
                <div className="p-4">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th className="">Date Submitted</th>
                        <th className="text-right">{ hasScore ? 'Score' : 'Action' }</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        submissions.map((submission, index)=>(
                          <tr key={index}>
                            <td>
                              <a href={`/organizations/${organizationName}/residents/${residentId}/survey_submissions/${submission.id}`}>
                                {moment(submission.created_at).format("MM/DD/YYYY @ h:mmA")}
                              </a>
                            </td>
                            <td className="text-right">
                              <a href={`/organizations/${organizationName}/residents/${residentId}/survey_submissions/${submission.id}`}>
                                { hasScore ? round(submission.get_score, 2) : 'View Submission'}
                              </a>
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              }
              {
                showPercentChange &&
                <div className="p-4">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th className="">Percent increase in quality of life</th>
                        <th className="text-right font-weight-normal">{percent_change}</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    ) :
    (
      <div>
        <h5 className="profile-header pt-4">{name}</h5>
        {
          hasScore && 
          <div className="pt-4">
            <LineChart data={submissions} dataKey="get_score"/>
          </div>
        }
        <div className="row">
          <div className="col-12 p-4">
            <table className="table table-sm table-responsive">
              <thead>
                <tr>
                  <th className="col-6">Date Submitted</th>
                  <th className="col-6">{ hasScore ? 'Score' : 'Action' }</th>
                </tr>
              </thead>
              <tbody>
                {
                  submissions.map((submission, index)=>(
                    <tr key={index}>
                      <td>
                        <a href={`/organizations/${organizationName}/residents/${residentId}/survey_submissions/${submission.id}`}>
                          {moment(submission.created_at).format("MM/DD/YYYY @ h:mmA")}
                        </a>
                      </td>
                      <td className="">
                        <a href={`/organizations/${organizationName}/residents/${residentId}/survey_submissions/${submission.id}`}>
                          { hasScore ? round(submission.get_score, 2) : 'View Submission'}
                        </a>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            {
              showPercentChange &&
              <table className="table table-sm table-responsive">
                <thead>
                  <tr>
                    <th className="col-6">Percent increase in quality of life</th>
                    <th className="col-6 font-weight-normal">{percent_change}</th>
                  </tr>
                </thead>
              </table>
            }
          </div>
        </div>
      </div>
    )
}
